import {
	ADD_TIP_GROUP_SSID,
	ADD_TIP_GROUP_SSID_COMPLETE,
	// DELETE_TIP_GROUP_SSID,
	DELETE_TIP_GROUP_SSID_FAIL,
	DELETE_TIP_GROUP_SSID_SUCCESS,
	EDIT_TIP_GROUP_SSID,
	EDIT_TIP_GROUP_SSID_COMPLETE,
	GET_TIP_GROUP_SSID_LIST,
	GET_TIP_GROUP_SSID_LIST_SUCCESS,
	GET_TIP_GROUP_SSID_LIST_FAIL,
	RESET_ADD_TIP_GROUP_SSID,
	TIP_INTERFACE_FETCH_FAIL,
	TIP_INTERFACE_FETCH_SUCCESS,
	OPEN_TIP_GROUP_SSID_MODAL,
} from '../constants/ssid/tipGroupSSIDConstants';

/**
 * Reducer function for managing ssid list state.
 *
 * This reducer handles actions related to fetching ssid data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the ssid list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const tipGroupSSIDReducer = (
	state = {
		tipGroupSsidList: {},
		editTIPGroupSSID: false,
		addTIPGroupSSIDResp: null,
		editTIPGroupSSIDData: {},
		editRow: null,
		deleteSuccessMessage: null,
		deleteFailMessage: null,
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case GET_TIP_GROUP_SSID_LIST:
			return {
				...state,
				loading: true,
			};
		case GET_TIP_GROUP_SSID_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				tipGroupSsidList: action.payload,
			};
		case GET_TIP_GROUP_SSID_LIST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case OPEN_TIP_GROUP_SSID_MODAL:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case ADD_TIP_GROUP_SSID:
			return {
				...state,
				loading: false,
			};
		case EDIT_TIP_GROUP_SSID:
			return {
				...state,
				loading: false,
			};
		case ADD_TIP_GROUP_SSID_COMPLETE:
			return {
				...state,
				loading: false,
				addTIPGroupSSIDResp: action.payload,
			};
		case EDIT_TIP_GROUP_SSID_COMPLETE:
			return {
				...state,
				loading: false,
				editTIPGroupSSIDData: action.payload,
			};
		case DELETE_TIP_GROUP_SSID_SUCCESS: {
			return {
				...state,
				deleteSuccessMessage: action.payload,
			};
		}
		case DELETE_TIP_GROUP_SSID_FAIL: {
			return {
				...state,
				deleteFailMessage: action.payload,
			};
		}
		case TIP_INTERFACE_FETCH_FAIL: {
			return {
				...state,
				interfaceError: action.payload,
			};
		}
		case TIP_INTERFACE_FETCH_SUCCESS: {
			return {
				...state,
				interfaceResult: action.payload,
			};
		}
		case RESET_ADD_TIP_GROUP_SSID:
			return {
				...state,
				loading: false,
				editTIPGroupSSID: false,
				editRow: null,
				deleteSuccessMessage: null,
				deleteFailMessage: null,
				editTIPGroupSSIDData: null,
				addTIPGroupSSIDResp: null,
			};
		default:
			return state;
	}
};
